import { ProductGroupViewModel, ProductChannelViewModel } from '@models/Product';
import { initialCoverageState, CoverageState } from './_components/coverage/coverage.reducer';
import { ContractDetailsViewModel } from '@models/Contract';
import { QuoteViewModel } from '@models/Quote';
import { PropertyInfoForm } from '@models/forms/PropertyInfoForm';
/**
 * This is a helper function for pulling the CoverageState out of a Quote or Contract Details View model
 */
export function pullCoverageStateFromEntity(entity: ContractDetailsViewModel | QuoteViewModel): CoverageState {
  let coverageState: CoverageState = {
    // copy the initial coverage state and add other safe access values
    ...initialCoverageState,
    selectedCoverageOptions: entity.coverageOptions,
    sellerCoverage: entity.sellerCoverage ? true : false,
    priceAdjustmentNotes: entity.priceAdjustmentNotes
  };

  if (entity.priceAdjustment) {
    // safely access price adjustment values
    coverageState = {
      ...coverageState,
      selectedPriceAdjustment: entity.priceAdjustment,
      overridePriceAdjustmentAmount: Math.abs(entity.priceAdjustmentAmount),
      selectedEmployeeDiscount: entity.employeeDiscount === null ? undefined : entity.employeeDiscount,
      isEmployeeDiscountEnabled: entity.priceAdjustment.id === 132 || entity.priceAdjustment.id === 134
    };
  }

  if (entity.product) {
    // safe access
    coverageState = {
      ...coverageState,
      selectedProductGroup: {
        id: entity.product.productGroupId
      } as ProductGroupViewModel,
      selectedProductChannel: {
        id: entity.product.productChannelId
      } as ProductChannelViewModel,
      selectedProduct: entity.product,
      selectedGroupId: entity.product.productGroupId,
      selectedChannelId: entity.product.productChannelId
    };
  }

  if (isContractDetailsViewModel(entity)) {
    coverageState = {
      ...coverageState,
      totalPrice: entity.termPrice
        ? entity.termPrice.totalPrice
        : +(entity.originalPrice || 0) + entity.priceAdjustmentAmount
    };
  }

  return coverageState;
}

function isContractDetailsViewModel(object: any): object is ContractDetailsViewModel {
  return 'contractNumber' in object;
}

export function pullPropertyInfoFromContractDetails(details: ContractDetailsViewModel): PropertyInfoForm {
  return {
    contactName: details.contactName,
    contactInit: details.contactInit,
    contactMedium: details.contactMedium,
    contactType: details.contactType,

    propertyAddress: details.propertyAddress,
    propertySaleType: details.propertySaleType,
    propertyType: details.propertyType,

    yearBuilt: details.yearBuilt ? '' + details.yearBuilt : ''
  };
}



// WEBPACK FOOTER //
// ./src/contract/contract.helpers.ts